module.exports = __webpack_public_path__ + "media/ח.393ba751.mp3";